module.exports = __webpack_public_path__ + "img/feature-invite-2.bef9dff6.jpg";